import React from "react";
import whoAreWe from "../../assets/images/who-are-we.svg";
import arrowGreen from "../../assets/images/arrow-green.svg";
import arrowWhite from "../../assets/images/arrow-white.svg";

const WhoAreWe = ({ isVisible }) => {
  return (
    <div className="who-are-we">
      {isVisible && (
        <>
          <img
            src={whoAreWe}
            alt="Who Are We"
            className="truck-animation truck"
          />
          <div className="line-green"></div>
        </>
      )}
      <div className="row">
        <div className="col-md-6 case-studies-outer bg-light-green  p-5">
          <div className="case-studies-inner mr-4">
            <h2 className="text-secondary fs-36 font-weight-light">
              Who we are?
            </h2>
            <p className="fs-14">
              SmartDrive’s video-based safety program makes<br></br> transport
              safer and smarter. The multi-faceted<br></br> solution is
              preferred by businesses to transform<br></br> fleet transport.
            </p>
          </div>
          <span>
            <img src={arrowGreen} alt="Arrow Green" />
          </span>
        </div>
        <div className="col-md-6 bg-secondary text-white case-studies-outer p-5">
          <div className="case-studies-inner mr-4">
            <h2 className="fs-36 font-weight-light">Join Us.</h2>
            <p className="fs-14">
              Let’s join hands to build sound and intelligent<br></br> transport
              safety programs that guard and guide the<br></br> way.{" "}
            </p>
          </div>
          <span>
            <img src={arrowWhite} alt="Arrow White" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default WhoAreWe;
